import fc from './fetchInterceptor';
import { queueESEvents, ESEventTypes } from './logEventToElasticSearch';

window.isHotJarInitialized = false;
export function loadHotJarTracking(hotJarSiteId) {
  try {
    // Initialise hotjar tracking plugi
    initializeHotJarFeedbackPlugin(hotJarSiteId);
  } catch (ex) {
    // hide hotjar due to error
    hideHotJarFeedbackPlugin();
    console.warn('Hiding Hotjar due to exception: ', ex);
    queueESEvents(ESEventTypes.HidingHotjarException, ex);
  }
}

function initializeHotJarFeedbackPlugin(hotJarSiteId) {
  if (window.isHotJarInitialized) return;

  // hotjar tracking code
  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: hotJarSiteId, hjsv: 5 };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
    console.log('hotjar append done', a, r);
  })(window, document, '//static.hotjar.com/c/hotjar-', '.js?sv=');

  window.isHotJarInitialized = true;
}

export function hideHotJarFeedbackPlugin() {
  let domHotjarPlugin = document.getElementById('_hj_feedback_container');

  if (domHotjarPlugin) domHotjarPlugin.style.visibility = 'hidden';
}

function showHotJarFeedbackPlugin() {
  let domHotjarPlugin = document.getElementById('_hj_feedback_container');

  if (domHotjarPlugin) domHotjarPlugin.style.visibility = 'visible';
}

///The function gets the Hot Jar tracking id from the server and then pass it again to load hot jar tracking
export function getHotJarTrackingId() {
  const apiHotjarIdUrl = window.APP.CONFIGURATION.VCCAPI + 'portalSettings/hotjartrackingid';
  fc.get(apiHotjarIdUrl)
    .then((data) => {
      if (data) {
        window.APP.CONFIGURATION.HOTJAR_SITE_ID = data;
        loadHotJarTracking(window.APP.CONFIGURATION.HOTJAR_SITE_ID);
      } else {
        console.err('Invalid Hot Jar id');
        queueESEvents(ESEventTypes.InvalidHotjarId, true);
      }
    })
    .catch((err) => {
      console.error('There was an API in getting the Hot Jar Id', err.toString());
      queueESEvents(ESEventTypes.GetHotJarIdError, err.toString());
    });
}
